export class DefaultSettingsModel {
	defaultBranchId?: string;
	defaultBranchName?: string;
	defaultClientId?: string;
	defaultClientName: string;
	defaultCMPBranchId?: string;
	defaultCMPBranchName?: string;
	defaultAppScopeUserCreation?: string;
	xpanseClientId?: string;
	clients?: Array<any> ;
}

export class BranchModel {
	id?: string;
	title?: string;
}

export class MilestoneMessageModel {
	id?: string;
	status?: string;
	origin?: string;
	message?: string;
	sendConfirmationToOrigin: boolean;
}
